<template>
    <lay-row space="10">
      <lay-col md="24">
        <lay-panel>
          <lay-form :model="search" style="text-align: start" size="sm">
 

            <lay-form-item label="状态" prop="type"  mode="inline">
                <lay-select v-model="search.type">
                    <lay-select-option value="0" label="无登录"></lay-select-option>
                    <lay-select-option value="1" label="登录"></lay-select-option> 
                </lay-select>
            </lay-form-item>
			
			<lay-form-item label="账号" prop="key"  mode="inline" v-if="search.type==1"> 
				 <lay-input v-model="search.key"></lay-input>
			</lay-form-item>  
            <lay-form-item mode="inline">
              <lay-button type="primary" size="sm" @click="searchUser">查询</lay-button>
            </lay-form-item>
  
          </lay-form> 

          <lay-table :page="page" :height="'100%'" :columns="columns" :loading="loading" :data-source="dataSource"
            v-model:selected-keys="selectedKeys" @change="change" @sortChange="sortChange">
			<template #state="{ row }">
				<span v-if="row.state==1">已处理</span>
				<span v-else>未处理</span>
			  
			</template>
			
            <template v-slot:operator="{ row }"> 
              <lay-button size="xs" type="primary" @click="updateAccessIntercept(row)" v-if="row.type==1&& row.state==0">禁用</lay-button>  
			  <lay-button size="xs" type="primary" @click="updateAccessIntercept(row)" v-if="row.type==1&& row.state==1">已禁用</lay-button>  
            </template>
          </lay-table> 
        </lay-panel>
  
      </lay-col>
  
  
    </lay-row>
    </template>
  
  <script lang="ts" setup>
  import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allAccessLog,accessIntercept} from '../../api'
 

  const search = reactive({
    type: "0", 
	key:""
  })
 

  

  const loading = ref(false);
  const dataSource = ref([]);
  const selectedKeys = ref([]);
  const page = reactive({ current: 1, limit: 10, total: 0 });
  const columns = ref([ 
     { title: "账号", key: "userName", align: "center"}, 
     { title: "访问地址", key: "path", align: "center" },
	 { title: "ip", key: "ip", align: "center" },  
	 { title: "来源", key: "referer", align: "center" },  
	 { title: "头部", key: "userAgent", align: "center" },   
	 { title: "状态", key: "state", align: "center", customSlot: "state" }, 
     { title: "访问时间", key: "addTime", align: "center" }, 
	 
	 
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
  ]);
  
  const getAllAccessLog = () => {
    loading.value = true;
	
    var data = { "page": page.current, "limit": page.limit, "type": search.type,"key": search.key };
    allAccessLog(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllAccessLog();
  
  
  const change = (page: any) => {
    getAllAccessLog();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  

//查看图片 
 
  //查询接口
  const searchUser = () => {
    page.current=1;
    getAllAccessLog();
  }
   
 
 
  const updateAccessIntercept = (row: any) => { 
  var data = { "key": row.userId, "id":row.state };
  accessIntercept(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
      getAllAccessLog();
      layer.msg("操作成功", { time: 1000, icon: 1 });
    }
  })
}
    
  
  </script>
  
  <style scoped></style>